import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";
import "../Body/Body.css";

export default function Body({ bannerData, links }) {
 
 

    
  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col>
              <div className="bannertextdesktop">
                <p>{htmlParser(bannerData.mastermindbannerheading)}</p>
              </div>
              <div className="bannertextsub">
                <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
                </div>
                <div className="bannertextsubpara">
                <p>{htmlParser(bannerData.mastermindsubheading2)}</p>
              </div>
              <img
                src={
                  "https://stagingresources.swmc.com/mastermind/june2023/mobileimg-swmc.webp"
                }
                className="mobilegroup img-fluild"
              ></img>
            </Col>
          </Row>
          <Col>
            <div className="editionbox">
            {/* <a
                  href="https://www.usemorgan.com/"
                  target="_blank"
                  rel="noreferrer"
                >
              <img
                src={
                  "https://stagingresources.swmc.com/mastermind/morganimg.webp"
                }
                className="morganimg img-fluild"
              ></img>
                </a> */}
              <div className="edition">
                <p className="textedition">
                  {" "}
                  {htmlParser(bannerData.monthedition)}
                </p>
              </div>
            </div>
            <div className="editionboxmobile">
            {/* <a
                  href="https://www.usemorgan.com/"
                  target="_blank"
                  rel="noreferrer"
                >
              <img
                src={
                  "https://d2b7dijo04ypct.cloudfront.net/mania/PostEvent/morganimg.webp"
                }
                className="mobilemorgan img-fluild"
              ></img>
               </a> */}
              <div className="editionmobilebox">
                <p className="editionmobiletext">
                  {" "}
                  {htmlParser(bannerData.monthedition)}
                </p>
              </div>
            </div>
          </Col>
        </Container>
      </div>
     
    </>
  );
}
